module.exports = __webpack_public_path__ + "static/media/skull-solid.63c8b224.svg";